import $ from 'jquery';

export default () => {
  if (!window.Localize) { return; }

  $(document).on('click', '[data-language-menu-item]', (e) => {
    const language = $(e.currentTarget).data('language');
    window.Localize.setLanguage(language);

    $('[data-language-menu-item]').removeClass('LanguageMenu__item--active');
    $(`[data-language-menu-item][data-language="${language}"]`).addClass('LanguageMenu__item--active');
  });
  
  // Set the saved/cached language on page load.
  const initial_language = window.Localize.getLanguage();
  $(`[data-language="${initial_language}"]`).eq(0).trigger('click');
};
